module.exports = {
  deleteAdminUser: 'deleteUser',
  changeAdminUserPassword: 'changeUserPassword',
  createAdminUser: 'createUser',
  ordersReport: 'ordersReport',
  getCompanyProducts: 'getCompanyProducts',
  importProducts: 'importProducts'
}